export default "__VITE_ASSET__5a670c4a__"